import { useDispatch, useSelector } from "react-redux";
import CustomDialog from "./CustomDialog";
import { setValidation, setShowMassage } from "../store/sysSlice";
import { Divider, Stack, TextField, Typography, } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";

const ValidationDialog = () => {
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const data = useSelector((state) => state?.sys.validation);
  const [validationData, setValidationData] = useState('')
  const [error, setError] = useState(false)

  useEffect(() => {
    if (data?.massage) {
      setValidationData('')
      setError(false)
    }
  }, [data]);

  const onClose = () => {
    dispatch(setValidation({ massage: null, onClick: () => { } }));
  };

  const onClick = () => {
    if (data?.validation && `${data?.validation}` !== `${validationData}`) {
      setError(true)
      dispatch(setShowMassage({ massage: "DATA_DOES_NOT_MATCH", type: "error" }));
      return
    }

    data?.onClick();
    onClose();
  };

  return (
    <CustomDialog
      title="VALIDATION_DIALOG"
      open={data?.massage ? true : false}
      onClose={onClose}
      closeBtn="CANCEL"
      actionBtn={{ title: 'CONTINUE', onClick: () => onClick() }}
    >
      <Stack height="100%" spacing={1}>

        <Typography textAlign='center' variant="h6">{bt("SENSITIVE_PLACE_INFO")}</Typography>
        <Typography textAlign='center' >{bt(data?.massage)}</Typography>

        {data?.validation
          ? <Stack alignItems='center' spacing={1}>
            <Divider sx={{ width: '100%' }} />
            <TextField
              fullWidth
              value={validationData}
              error={error}
              onChange={(e) => setValidationData(e.target.value)}
            />
            <Divider sx={{ width: '100%' }} />
          </Stack>
          : null
        }
      </Stack>
    </CustomDialog>
  );
};
export default ValidationDialog;
